// fix this
/* eslint-disable import/no-cycle */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-multi-assign */
/* eslint-disable no-shadow */
/* eslint-disable prefer-rest-params */
/* eslint-disable import/extensions */
import Cookies from 'cookie-universal';
import md5 from 'blueimp-md5';
import { init as SentryInit, configureScope, captureException } from '@sentry/browser';
import { Vue as SentryVue } from '@sentry/integrations/esm/index';
import Vue from 'vue';
import UserService from '@/services/UserService';
import LocationService from '@/services/LocationService';
import { validateEmail } from './utils.js';
import { flatten } from 'flat';

const TRACKING_OPT_OUT_COOKIE = 'data-opt-out';

export default class Tracking {
  static init() {
    try {
      window.dataLayer = window.dataLayer || [];

      if (!window.article) {
        window.article = {};
      }
      if (!window.article.data) {
        window.article.data = {};
      }

      if (!process.env.DEBUG && process.env.CONFIG_SENTRY_RELEASE) {
        Tracking.initSentry();
      }

      document.addEventListener('DOMContentLoaded', () => {
        Tracking.loadHeapAnalytics();
        Tracking.stitch();
        Tracking.watchForms();
      });

      document.addEventListener(
        'change',
        function (e) {
          window.dataLayer.push({
            event: 'gtm.' + e.type,
            'gtm.element': e.target,
            'gtm.elementClasses': e.target.className || '',
            'gtm.elementId': e.target.id || '',
            'gtm.elementTarget': e.target.target || '',
            'gtm.elementName': e.target.name || '',
            'gtm.elementUrl': e.target.href || e.target.action || '',
            'gtm.originalEvent': e,
          });
        },
        false,
      );

      Tracking.exposeGeoData();
    } catch (e) {
      console.warn('Failed to initialise tracking');
      console.warn(e);
    }
  }

  /**
   * Primary method of tracking an event and associated data.
   *
   * Data will be exposed to:
   * - GTM - available as a data layer variable (via window.dataLayer). A new custom event trigger can be added to GTM based on the event name.
   * - Heap - available as a heap event and associated heap event properties
   *
   * If a third party library needs access to an event, please add a new tag to Google Tag Manager.
   *
   * @param {String} name Name of the event. If null then properties are still merged but a tracking event is not triggered.
   * @param {Object} properties Event data to merge into the existing tracked properties
   */
  static track(name, properties) {
    if (process.env.DEBUG) {
      console.log('Tracking.track', name, properties);
    }
    try {
      if (typeof window === 'undefined') {
        console.warn(`Can't track ${name} without a window object available`);
        return;
      }

      if (!window.article || !window.article.data || !window.dataLayer) {
        Tracking.init();
      }

      if (name && typeof name !== 'string') {
        console.warn(`Event tracking expected a string event name but got '${name}'`);
        return;
      }

      if (properties && typeof properties !== 'object') {
        console.warn(`Event tracking for '${name}' expects an object parameter but was given '${properties}'`);
        return;
      }

      if (name) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: name,
            ...properties,
          });
        }

        const propertiesFlat = properties ? flatten(properties) : null;
        if (Tracking.heap) {
          Tracking.heap.track(name, propertiesFlat);
        } else {
          Tracking.heapTrackEvents = {
            name,
            properties: propertiesFlat,
          };
        }
      } else {
        if (window.dataLayer) {
          window.dataLayer.push(properties);
        }
      }
    } catch (e) {
      console.warn(`Failed to track the ${name} event with properties ${properties}`);
      console.warn(e);
    }
  }

  static expose(key, value) {
    article.data[key] = value;
  }

  static stitch() {
    const email = UserService.getEmail();

    if (email) {
      Tracking.identify(email);
    } else {
      const idArr = location.href.split('_u_id_=');
      if (idArr.length === 2) {
        const id = idArr[1].split(/[?#&]/)[0].toLowerCase().replace('-', '');
        // Check if id is specified; if it contains the string "UID", it is probably
        // a bug with the link sender (MailChimp as of time of writing)
        if (id.length > 0 && !/[^0-9a-f]/.test(id)) {
          Tracking.heap.identify(id, 'Email Hash');
        }
      }

      Tracking.sentryIdentify();
    }
  }

  static identify(email) {
    Tracking.heapIdentify(email);
    Tracking.sentryIdentify(email);
  }

  static initSentry() {
    SentryInit({
      dsn: process.env.SENTRY_DNS,
      release: process.env.CONFIG_SENTRY_RELEASE || '', // Config set in Webpack
      integrations: [new SentryVue({ Vue })],
      environment: process.env.NODE_ENV,
      ignoreErrors: [
        /Blocked a frame with origin/, // Ignore error caused by bug in iOS Chrome autofill
      ],
    });
  }

  static sentryIdentify(email) {
    try {
      const heapProperties = Tracking.getHeapAnalyticsProperties() || {};
      const userProperties = email
        ? {
            email,
            emailHash: md5(email),
            id: email,
          }
        : {
            id: heapProperties.identity,
          };

      configureScope((scope) => {
        scope.setUser({
          heapSessionId: heapProperties.sessionId,
          heapPageviewId: heapProperties.pageviewId,
          heapUserId: heapProperties.userId,
          heapIdentity: heapProperties.identity,
          sessionZipLocationZipCode: LocationService.getZipLocation()?.zipcode,
          sessionGeoLocationZipCode: LocationService.getGeoLocation()?.zipcode,
          sessionRegionCode: LocationService.getPreferredLocation().regionCode,
          sessionPreferredZip: LocationService.getPreferredLocation().zipcode,
          sessionSelectedCountryId: LocationService.getCountryId(),
          sessionCity: LocationService.getPreferredLocation().city,
          sessionRegionId: LocationService.getPreferredLocation().regionId,
          sessionCurrencyId: LocationService.getCurrencyId(),
          sessionCountryId: LocationService.getPreferredLocation().countryId,
          sessionCart: UserService.getCart(),
          ...userProperties,
        });
      });
    } catch (e) {
      console.warn('Sentry identify failed');
      console.warn(e);
    }
  }

  static sentryCaptureError(error) {
    try {
      console.error(error);
      captureException(error);
    } catch (err) {
      console.error(err);
    }
  }

  static get heap() {
    if ('heap' in window) {
      return window.heap;
    }
    return null;
  }

  static get heapEventProperties() {
    return window.heapEventProperties || [];
  }

  static set heapEventProperties(heapEventProperties) {
    window.heapEventProperties = heapEventProperties;
  }

  static heapAddEventProperties(properties) {
    if (Tracking.heap) {
      Tracking.heap.addEventProperties(properties);
    } else {
      // Heap has not loaded so we will queue up the event properties
      Tracking.heapEventProperties = [
        ...Tracking.heapEventProperties,
        {
          action: Tracking.heapAddEventProperties,
          properties,
        },
      ];
    }
  }

  static heapRemoveEventProperty(name) {
    if (Tracking.heap) {
      Tracking.heap.removeEventProperty(name);
    } else {
      // Heap has not loaded so we will queue up the event properties
      Tracking.heapEventProperties = [
        ...Tracking.heapEventProperties,
        {
          action: Tracking.heapRemoveEventProperty,
          properties: name,
        },
      ];
    }
  }

  static get heapUserProperties() {
    if ('heapUserProperties' in window) {
      return window.heapUserProperties;
    }
    return {};
  }

  static set heapUserProperties(property) {
    window.heapUserProperties = { ...window.heapUserProperties, ...property };
  }

  static heapAddUserProperties(properties) {
    if (Tracking.heap) {
      Tracking.heap.addUserProperties(properties);
      window.heapUserProperties = {};
    } else {
      Tracking.heapUserProperties = properties;
    }
  }

  static get heapTrackEvents() {
    return window.heapTrackEvents;
  }

  static set heapTrackEvents({ name, properties }) {
    window.heapTrackEvents = { ...window.heapTrackEvents, [name]: properties };
  }

  static heapIdentify(emailRaw) {
    try {
      const email = emailRaw.toLowerCase();

      Tracking.heap.identify(email, 'Email');
      Tracking.heap.identify(md5(email), 'Email Hash');
      Tracking.heap.addUserProperties({ Email: email });
    } catch (e) {
      console.warn('Heap identify failed');
      console.warn(e);
    }
  }

  static heapCaptureEmailFromForm(form) {
    const emailField = form.attributes._u_id_name_?.value;
    if (emailField) {
      try {
        const email = form.querySelector(`input[type='${emailField}']`)?.value;

        Tracking.heapIdentifyEmail(email);
      } catch (error) {
        console.error(error);
      }
    }
  }

  static heapIdentifyEmail(email) {
    if (validateEmail(email)) {
      Tracking.heapIdentify(email);
    }
  }

  static watchForms() {
    const form = document.querySelector('form[_u_id_name_]');
    if (form) {
      const forms = document.querySelectorAll('form[_u_id_name_]');

      for (let i = 0; i < forms.length; i++) {
        forms[i].addEventListener('submit', (e) => Tracking.heapCaptureEmailFromForm(e.target), false);
      }
    }
  }

  static loadHeapAnalytics() {
    window.heap = window.heap || [];
    heap.load = function (e, t) {
      window.heap.appid = e;
      window.heap.config = t = t || {};
      const r = t.forceSSL || document.location.protocol === 'https:';
      const a = document.createElement('script');
      a.type = 'text/javascript';
      a.async = !0;
      a.src = `${r ? 'https:' : 'http:'}//cdn.heapanalytics.com/js/heap-${e}.js`;
      const n = document.getElementsByTagName('script')[0];
      n.parentNode.insertBefore(a, n);
      for (
        let o = function (e) {
            return function () {
              heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            };
          },
          p = [
            'addEventProperties',
            'addUserProperties',
            'clearEventProperties',
            'identify',
            'removeEventProperty',
            'setEventProperties',
            'track',
            'unsetEventProperty',
          ],
          c = 0;
        c < p.length;
        c++
      )
        heap[p[c]] = o(p[c]);
    };
    if (process.env.STOREFRONT) {
      if (!process.env.STOREFRONT_SERVER) {
        Tracking.heap.load(process.env.HEAP_KEY);
      }
    } else if (!process.env.STOREFRONT) {
      Tracking.heap.load(window.article.heapKey);
    }

    if (Tracking.heapEventProperties && Tracking.heapEventProperties.length) {
      // If properties were added before heap was loaded, we will add them to heap now
      Tracking.heapEventProperties.forEach(({ action, properties }) => action(properties));
      Tracking.heapEventProperties = [];
    }

    if (Tracking.heapUserProperties) {
      Tracking.heapAddUserProperties(Tracking.heapUserProperties);
    }

    if (Tracking.heapTrackEvents) {
      Object.keys(Tracking.heapTrackEvents).forEach((key) => {
        Tracking.track(key, Tracking.heapTrackEvents[key]);
      });
    }
  }

  static getHeapAnalyticsProperties() {
    try {
      if (Tracking.heap) {
        const heapCookies = Cookies().get(`_hp2_id.${Tracking.heap.appid}`, { parseJSON: false });
        if (heapCookies) {
          return JSON.parse(decodeURIComponent(heapCookies));
        }
      }
    } catch (error) {
      // console.error(error);
      return {};
    }

    return {};
  }

  static resetHeapIdentity() {
    try {
      if (Tracking.heap) {
        Tracking.heap.resetIdentity();
      }
    } catch (error) {
      console.error(error);
    }
  }

  static exposeGeoData() {
    const { regionCode } = LocationService.getPreferredLocation();
    const selectedZip = LocationService.getZipLocation()?.zipcode;
    const displayedZip = LocationService.getPreferredLocation().zipcode;
    const detectedZip = LocationService.getGeoLocation()?.zipcode;

    window.article.data.geo = {
      regionCode: regionCode || 'unknown',
      zip: selectedZip || displayedZip,
      selectedZip,
      zipAccuracyRadius: LocationService.getPreferredLocation().accuracyRadius,
      detectedZip,
    };
  }

  static loadGoogleAnalytics() {
    try {
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    } catch(e) {
      console.error(e);
    }
  }

  static loadGoogleTagManager() {
    try {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.defer = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', process.env.GTM_APP_KEY);
    } catch(e) {
      console.error(e);
    }
  }

  static getTrackingOptOut() {
    try {
      return !!Cookies().get(TRACKING_OPT_OUT_COOKIE);
    } catch(e) {
      Tracking.sentryCaptureError(e);
    }
    return false;
  }

  static setTrackingOptOut(val) {
    try {
      if(val) {
        Cookies().set(TRACKING_OPT_OUT_COOKIE, 'true', {
          expires: new Date('2038-01-01T00:00:00Z'),
          sameSite: 'lax',
          path: '/'
        });
      } else {
        Cookies().remove(TRACKING_OPT_OUT_COOKIE);
      }
    } catch(e) {
      Tracking.sentryCaptureError(e);
    }
  }
}
